import { axiosInstance } from "./apiInstance";

/**
 *
 * @param {string} path
 * @param {string} programtype
 * @param {FormData} fd
 * @returns {object}
 */

async function hitApi2(path, programtype, fd) {
  fd.append("programType", programtype);
  fd.append("authToken", localStorage.getItem("authToken") || "");
  fd.append("session", localStorage.getItem("session") || "");
  fd.append("centerBranch", localStorage.getItem("branch-id") || "");

  try {
    const response = await axiosInstance.post(path, fd);
    console.log(response.data);
    if (response.data.success) {
      return response.data;
    } else {
      if (
        response.data.data === "Unauthorized user" &&
        window.location.pathname !== "/login"
      ) {
        window.location.href = "/login";
        return { data: [], success: false, message: "Unauthorized User" };
      }
      return response.data;
    }
  } catch (error) {
    console.log(error);
    return error;
  }
}

export { hitApi2 };
